import { BaseModel } from "sjs-base-model";

export default class SingleIsinReportStatDataItemModel extends BaseModel {
    reportId = 0;
    totalAmount = 0;
    created = "";
    email = "";
    bpId = 0;
    
    constructor(data) {
        super();
        this.update(data);
    }

    update(data) {
        super.update(data);
        this.bpId = this.bpId === null || this.bpId === "" ? "N/A" : this.bpId;
    }
}
